import {
  customScrollMinimal,
  TableCell,
  TableHeader,
  TanStackTableRoot,
  typographyV2,
} from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const StyledTanStackTableRoot = styled(TanStackTableRoot)`
  width: 100%;
`;

export const StyledTableHeader = styled(TableHeader)`
  position: sticky;
  left: 0;
  top: 0;
  border-bottom: 1px solid var(--border-default);
  z-index: var(--z-index-header-cell);
`;

export const TableWrapper = styled.div<{ $isLoading: boolean }>`
  ${customScrollMinimal};
  overflow-y: auto;
  flex: 1 1 0px;
  width: 100%;
  height: 100%;
  z-index: 1;

  tbody tr td:first-child {
    border-left: 1px solid var(--border-soft);
  }

  tbody tr td:last-child {
    border-right: 1px solid var(--border-soft);
  }

  tbody tr:first-child td {
    border-top: none;
  }

  thead tr th:first-child {
    border-left: 1px solid var(--border-soft);
  }

  thead tr th:last-child {
    border-top-right-radius: 8px;
    border-right: 1px solid var(--border-soft);
  }

  thead tr th {
    border-top: 1px solid var(--border-soft);
  }

  ${({ $isLoading }) =>
    $isLoading
      ? css`
          table tr:last-child td {
            border-bottom: none;
          }
        `
      : css`
          tbody tr:last-child td {
            border-bottom: none;
            border-left: none;
            border-right: none;
          }

          tbody tr:not(:last-child) td {
            border-bottom: 1px solid var(--border-soft);
          }

          tbody tr:nth-last-child(2) td:first-child {
            border-bottom-left-radius: 8px;
          }

          tbody tr:nth-last-child(2) td:last-child {
            border-bottom-right-radius: 8px;
          }
        `}
  table tr:last-child td {
    cursor: default;

    &:hover {
      background-color: var(--background-default);
    }
  }
`;

export const StyledTableCell = styled(TableCell)`
  white-space: normal;
`;

export const FooterRow = styled(TableCell)`
  padding: 20px 20px 0 20px;
`;

export const RankWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;

export const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 240px;
`;

export const DescriptionWrapper = styled.div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const NameLabel = styled.span`
  margin-left: 8px;
`;
